import React, { Fragment, useState, useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import Breadcrumb from "../../../layout/breadcrumb";
import { deleteType, editTypes, getAllSalutation,editSalutation } from "../../../api";
import { toast } from "react-toastify";
import { MaterialReactTable } from "material-react-table";
import formatedDate from "../../../utilities/formatedDate";
import GetButtons from "../../common/getButtons";
import StatusCells from "../../common/statusCells";
import AddSalutation from "./AddSalutation";

const Salutation = () => {

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([{ "id": "category_id", "desc": true }]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  useEffect(() => {
    getMasterTypesData(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      columnFilters,
      sorting
    );
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, columnFilters, sorting]);


  const getMasterTypesData = async (page, rowsPerPage, searchText, columnFilters, sorting) => {
    setData([['Loading Data...']]);
    try {
      setIsLoading(true);
      const data = await getAllSalutation();
      console.log(data, 'data123')
      if (data) {
        setData(data.data?.result);
        setCount(data.data?.result?.length);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error:", error);
      toast.error(error.response.data.error)
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "title",
        header: "Title",
        // enableSorting: false,
        // filter: false,
        // enableColumnFilter: false,
        // enableColumnActions: false,
        Cell: ({ row }) => <div title={row?.original?.title}>{row?.original?.title}</div>,
      },
      {
        accessorKey: "is_active",
        header: "Status",
        enableSorting: false,
        filter: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        filterSelectOptions: [
          { text: 'Active', value: "1" },
          { text: 'Deactivate', value: "0" },
        ],
        filterVariant: 'select',
        Cell: ({ row }) => (
          <StatusCells
            row={row}
            refresh={refresh}
            updateStatus={editSalutation}
            // checkAccess={() => CheckAccess("dealership", "ACTIVATE")}
            // activatedStatus={activateFuel}
            dataId={row.original.salutation_id}
          />
        )
      },
      {
        accessorKey: "created_at",
        header: "Created At",
        filter: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        enableFilters: false,
        Cell: ({ row }) => (
          <div>
            {formatedDate(row?.original?.created_at)}
          </div>
        ),

      },
      {
        accessorKey: "updated_at",
        header: "Updated At",
        filter: false,
        enableColumnFilter: false,
        enableColumnActions: false,
        enableFilters: false,
        Cell: ({ row }) => (
          <div>
            {formatedDate(row?.original?.updated_at)}
          </div>
        ),

      },
    ],
    []
    //end
  );

  const refresh = () => {
    getMasterTypesData(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      columnFilters,
      sorting
    )
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };


  const handleSearch = () => {
    getMasterTypesData(
      pagination.pageIndex,
      pagination.pageSize,
      globalFilter,
      columnFilters,
      sorting
    );
  };

  return (
    <Fragment>
      <Breadcrumb parent="Masters" title="Salutation" />
      <div>
        <MaterialReactTable
          enableSorting={false}
          columns={columns}
          data={data || []}
          initialState={{ showColumnFilters: false, density: "compact" }}
          enableGlobalFilter={false}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFiltersChange={setColumnFilters}
          // onColumnFiltersChange={(newColumnFilters) => {
          //   setColumnFilters(newColumnFilters);
          // }}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          muiTableBodyProps={{
            sx: {
              '& td': {
                paddingTop: '8px',
                paddingBottom: '8px',
              },
            },
          }}
          renderTopToolbarCustomActions={({ table }) => (
            <>

              <Box sx={{ display: 'flex', gap: '0.3rem', p: '0.5rem', flexWrap: 'wrap', position: 'sticky', zIndex: '1' }} >
                {/* <GetButtons onClick={handleSearch} type="submit" name="Search" /> */}

                <GetButtons onClick={handleSearch} type="refresh" name="Refresh" customIcon="fa fa-search" />
                {/* <GetExport columns={columns} exportedData={exportedData} name="Salutation" /> */}
                <GetButtons onClick={toggleModal} type="add" />

              </Box>


            </>
          )}
          rowCount={count}
          state={{
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            sorting,
          }}
        />
      </div>
      {isModalOpen ?
        <AddSalutation isOpen={isModalOpen} toggle={toggleModal} refreshPage={refresh} /> : null}
    </Fragment>
  );
};

export default Salutation;